<template>
    <div class="m-bars" :class="{ 'm-bars--dark' : onDark }">
        <button v-if="button" class="a-button" @click="bars">show results</button>
        <slot></slot>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: 'value-bars',
        props: {
            button: {
                type: Boolean,
                default: false,
            },
            values: {
                type: Array,
            },
            onDark: {
                type: Boolean,
            }
        },
      	watch : {
            values: function () {
                this.bars()
            }
        },
        methods: {
            bars(){
                const bars = this.values;
                const largest = Math.max.apply(Math, bars);
                const headings = document.querySelectorAll('.m-bars h3');

                for (let i = 1; i <= bars.length; i++) {
                    const currentBar = document.querySelector(".bar" + i);
                    const multiplier = i/bars.length;
                    const currentBarText = document.querySelector(".bar" + i + " span");

                    if(bars[0] > 0) {
                        document.querySelector('.bar' + i).style.width = bars[i - 1]/largest*100 + '%';
                        currentBarText.style.opacity = "1";
	                }
                    
                    headings[i - 1].style.display = 'block';
                    currentBar.style.display = "block";
                    currentBar.style.background = this.onDark == true ? "rgba(74, 137, 229, 1)" : "rgba(74, 137, 229, " + multiplier + ")";
                    currentBarText.innerHTML = bars[i-1];
                }
               
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ValueBars.vue?1eb6e8eb